import(/* webpackMode: "eager" */ "/codebuild/output/src2326840661/src/seedkit-nextjs-frontend/src/app/page.js");
